import { render } from "./UploadModal.vue?vue&type=template&id=9f9b5bd0&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"

import "./UploadModal.vue?vue&type=style&index=0&id=9f9b5bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9b5bd0"]])

export default __exports__